<ng-container *ngFor="let item of items">
  <label class="example-margin">{{ item.label }}</label>
  <mat-radio-group>
    <mat-radio-button
      class="example-margin"
      value="{{ item.value }}"
    ></mat-radio-button>
  </mat-radio-group>
</ng-container>
